<template>
  <v-img
    :src="
      $vuetify.breakpoint.mdAndUp
        ? '/videos/portada-web.jpg'
        : '/videos/portada-movil.jpg'
    "
    class="d-flex justify-center align-center"
    height="100vh"
  >
    <v-layout class="ml-12 margin2" style="position:absolute;">
      <v-flex xs10 sm10 md6 lg4>
        <v-img class="image" contain :src="`${publicPath}imagenes/colegio_vizcaya.png`"></v-img>
      </v-flex>
    </v-layout>
    <v-layout fill-height class="ml-12 margin" v-if="$vuetify.breakpoint.mdAndUp">
      <v-flex xs10 sm10 md6 lg4>
        <v-select
          v-model="city"
          :items="cities"
          solo
          color="white"
          item-text="name"
          item-value="id"
          label="Elige el plantel que deseas visitar"
          @change="goToHome()"
        ></v-select>
          <div class="justify-start align-center d-flex" :class="[$vuetify.breakpoint.mdAndUp ? 'flex-row' : 'flex-column']">
            <v-btn color="white" large class="mt-5" @click="goToHome">Visitar</v-btn>
            <BotonPrincipal/>
          </div>
        <v-snackbar v-model="snackbar">
          Selecciona el plantel que deseas visitar
          <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
    <v-layout fill-height class="ml-12 margin" v-else>
      <v-flex xs10 sm10 md6 lg4>
        <v-select
          v-model="city"
          :items="cities"
          solo
          color="white"
          item-text="name"
          item-value="id"
          label="Plantel a visitar"
          @change="goToHome()"
        ></v-select>
        <div class="justify-start align-center d-flex" :class="[$vuetify.breakpoint.mdAndUp ? 'flex-row' : 'flex-column']">
          <v-btn color="white" large class="mt-5" @click="goToHome">Visitar plantel</v-btn>
          <BotonPrincipal/>
        </div>
        <v-snackbar v-model="snackbar">
          Selecciona el plantel que deseas visitar
          <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-img>
</template>
<style scoped>
@media (max-width: 600px) {
  .margin {
    margin-top: 400px;
  }
  .margin2 {
    margin-top: 280px;
  }
  .image {
    width: 20em;
  }
}
@media (min-width: 601px) and (max-width: 1023px) {
  .margin {
    margin-top: 500px;
  }
  .margin2 {
    margin-top: 300px;
  }
  .image {
    width: 40em;
  }
}
@media (min-width: 1024px) and (max-width: 1264px) {
  .margin {
    margin-top: 400px;
  }
  .margin2 {
    margin-top: 200px;
  }
  .image {
    width: 60em;
  }
}
@media (min-width: 1265px) and (max-width: 1904px) {
  .margin {
    margin-top: 310px;
  }
  .margin2 {
    margin-top: 150px;
  }
  .image {
    width: 70em;
  }
}
@media (min-width: 1905px) {
  .margin {
    margin-top: 450px;
  }
  .margin2 {
    margin-top: 230px;
  }
  .image {
    width: 110em;
  }
}
</style>
<script>
import BotonPrincipal from "../components/BotonPrincipal.vue";
import { mapState } from "vuex";
import lodash from "lodash";
export default {
  components: {
    BotonPrincipal
  },
  mounted() {
    // setTimeout(function(){ 
    //   var social_media_whatsapp = document.getElementById("social_media_whatsapp");
    //   social_media_whatsapp.setAttribute('href', 'https://wa.me/523113766390/?text=Hola%20Colegio%20Vizcaya');
    //   document.getElementById("social_media_whatsapp").style.display = "inline-flex";
    //   var social_media_facebook = document.getElementById("social_media_facebook");
    //   social_media_facebook.setAttribute('href', "https://www.facebook.com/Colegio-Vizcaya-178827478923600");
    // }, 2000);
  },
  data: () => ({
    publicPath: process.env.BASE_URL,
    snackbar: false,
    city: "",
  }),
  methods: {
    goToHome() {
      if (this.city != "") {
        var fromlink = _.find(this.cities, ["id", this.city]);
        location.assign("/" + fromlink.link + "/inicio");
      } else {
        this.snackbar = !this.snackbar;
      }
    },
  },
  computed: {
    ...mapState({
      cities: (state) => state.cities.cities,
      campus: state => state.cities.campus,
      city_selected: (state) => state.cities.city_selected,
    })
  }
};
</script>
